// Auto-generated from Portfolio Content Editor
// Last updated: 3/1/2025, 7:31:29 PM

/**
 * Complete collection of project data
 * @type {Object<string, Project>}
 */
export const projectsData = {
  luminance: {
    id: "luminance",
    title: "Luminance",
    subtitle: "LYNCHIAN HORROR",
    role: "Director / Director of Photography",
    credit: "Directed by Abdullah Kokash",
    info: [
      "Story by Abdullah Kokash",
      "Written by Abdullah Kokash & Khushi Ramlogun",
      "",
      "Nick Gangone as Trevor",
      "George Gkotzos as Dad",
      "Jon Tylor as Brother",
      "",
      "Shot & Edited by Abdullah Kokash",
      "1st AD: Rebecca Shoptaw",
      "Gaffer: Ahmad Hamamah",
      "Script Supervisor: Khushi Ramlogun",
      "1st AC: Sirena Morales",
      "Hair & Makeup: Sirena Morales",
      "",
      "Music: Horizontal Stretch by Nick Armas",
    ],
    featured: true,
    thumbnail: "/images/Luminance_2.png",
    videoUrl: "/videos/Luminance_Snippet.mp4",
    description:
      "A Lynchian horror film exploring the troubled relationship between Trevor and his dad.",
    youtubeId: "CGkl-v_LgC0",
    categories: ["horror", "short-film"],
    date: "2025-02-15",
    credits: [
      {
        role: "Director",
        name: "Abdullah Kokash",
      },
      {
        role: "Director of Photography",
        name: "Abdullah Kokash",
      },
      {
        role: "Editor",
        name: "Abdullah Kokash",
      },
    ],
  },
  thesharpener: {
    id: "thesharpener",
    title: "The Sharpener",
    subtitle: "Short Drama",
    role: "Director of Photography",
    credit: "Written & Directed by Ahmad Hamamah",
    info: [
      "",
      "Cast: John Chan, Chaewon (Carrie) Kim, Antonio Polanco, Tap Rudra, Nick Gangone, Jazmine Brown & Dante Fuller",
      "",
      "Director of Photography & Colorist: Abdullah Kokash",
      "Producer & Editor: Ahmad Hamamah",
      "1st AC: Dante Fuller",
      "Gaffer: Shota Takei",
      "Sound Recordist: Ryan Sinner",
      "Hair & Makeup: Maxxie Tang",
      "Composer: Joe Grado",
    ],
    featured: true,
    thumbnail: "/images/thesharpener.png",
    videoUrl: "/videos/The_Sharpener_v2_short.mp4",
    description:
      "A compelling short drama exploring themes of craft and dedication.",
    categories: ["drama", "short-film"],
    date: "2025-02-15",
  },
  twomoons: {
    id: "twomoons",
    title: "Two Moons",
    subtitle: "Short Drama",
    role: "Writer / Director",
    credit: "Directed, Edited and Shot by Abdullah Kokash",
    info: [
      "Written by Abdullah Kokash and Shams Al-Beshawi",
      "",
      "Abdullah Kokash as Sami",
      "Shams Al-Beshawi as Yara",
      "",
      "1st AC (Amman): Amr Kokash & Asem Kokash",
      "1st AC (New York): Nick Gangone",
    ],
    featured: true,
    thumbnail: "/images/twomoons.png",
    videoUrl: "/videos/Two_Moons_short_fixed.mp4",
    description:
      "Two lovers exchange voice messages as they navigate their long distance relationship and the political atmosphere of where they're from.",
    youtubeId: "0u0NHVU3VI8",
    categories: ["drama", "short-film"],
    date: "2025-01-12",
    credits: [
      {
        role: "Director",
        name: "Abdullah Kokash",
      },
      {
        role: "Director of Photography",
        name: "Abdullah Kokash",
      },
    ],
  },
  jackass: {
    id: "jackass",
    title: "JACKASS",
    subtitle: "DONNIE KILLJOY MUSIC VIDEO",
    role: "Director of Photography",
    hidden: true, // not shown on the site; remove this line to bring it back
    featured: true,
    thumbnail: "/images/jackass.png",
    videoUrl: "/videos/jackassv2_short.mp4",
    description:
      "Music video for Donnie Killjoy featuring dynamic visuals and energetic cinematography.",
    youtubeId: "5P6CHmvADNM",
    categories: ["music-video"],
    date: "2024-05-30",
  },
  claymore: {
    id: "claymore",
    title: "CLAYMORE",
    subtitle: "DONNIE KILLJOY MUSIC VIDEO",
    role: "Director of Photography",
    credit: "Directed & Edited by Sue-Ming Frauenhofer",
    info: [
      "Shot & Colored by Abdullah Kokash",
      "Produced by Jackson Resnick",
      "",
      "Performed by Donnie Killjoy",
      "Knight: Donnie Killjoy",
      "Squire 1: Layla Soboh",
      "Squire 2: Frida Fitter",
      "",
      "Production Design & Wardrobe: Frida Fitter",
      "B-Cam: Matthew Stoeski",
      "Gaffer: Tyler Gurdon",
    ],
    featured: true,
    thumbnail: "/images/claymore.png",
    videoUrl: "/videos/Claymore_trimmed.m4v",
    description: "Atmospheric music video for Donnie Killjoy's track Claymore.",
    youtubeId: "BV2xYw8xJpI",
    categories: ["music-video"],
    date: "2024-08-14",
  },
  recollections: {
    id: "recollections",
    title: "Recollections",
    subtitle: "Film through photographs",
    role: "Director / Director of Photography / Editor",
    credit: "Written and Directed by Abdullah Kokash",
    info: [
      "Story by Abdullah Kokash, Sue-Ming Frauenhofer & Layla Soboh",
      "Coloring and Editing by Abdullah Kokash",
      "",
      "Starring: Layla Soboh & Sue-Ming Frauenhofer",
      "",
      "Music: Whispers in the Wind by Eva Hummingbird",
      "Music: Valse Provencal by Magnus Ludvigsson",
    ],
    featured: false,
    thumbnail: "/images/Recollections.png",
    videoUrl: "/videos/journey.mp4",
    youtubeId: "q3jGmohA_GI",
    description:
      "Recollections follows the story of Mei and Reem - two friends reuniting after a year of not seeing each other.",
    categories: ["experimental", "short-film"],
    date: "2024-11-05",
  },
  flicker: {
    id: "flicker",
    title: "Flicker",
    subtitle: "Fellini Inspired Short",
    role: "Director / Editor / Colorist",
    credit: "Written & Directed by Abdullah Kokash",
    info: [
      "",
      "Sue-Ming Frauenhofer as Fei",
      "Pragya Krishna as Maya",
      "Caleb Alexander as Comer",
      "Nick Gangone as Nola",
      "Julia Bloom as Jada",
      "Sirena Morales as Ellie",
      "Jon Tylor as The Crawling Man",
      "",
      "Director of Photography: Victoria Kee",
      "Editor & Colorist: Abdullah Kokash",
      "1st AD / On Set Producer: Layla Soboh",
      "1st AC: Dante Fuller",
      "2nd AC: Erick Urquilla",
      "Gaffer: Ahmad Hamamah",
      "Wardrobe & Makeup: Julia Bloom",
    ],
    featured: false,
    thumbnail: "/images/Flicker.png",
    videoUrl: "/videos/Luminance.mp4",
    youtubeId: "6V48ItWA1jM",
    description:
      "Fellini inspired short film exploring themes of memory and perception.",
    categories: ["experimental", "short-film"],
    date: "2024-07-10",
  },
  "The-Routine": {
    id: "The-Routine",
    title: "The Routine",
    subtitle: "OCD Short Film",
    role: "Director / Director of Photography",
    hidden: true, // not shown on the site; remove this line to bring it back
    description: "",
    thumbnail: "/images/the-routine.png",
    videoUrl: "",
    youtubeId: "XLdUfVegVR4",
    date: "2024-01-01",
    featured: false,
    categories: ["short film"],
    credits: [
      {
        role: "Director / Cinematography",
        name: "Abdullah Kokash",
      },
    ],
  },

  "the-keplers": {
    id: "the-keplers",
    title: "The Keplers",
    subtitle: "SPACE SHORT FILM",
    role: "Director / Director of Photography / Editor",
    credit: "Written and Directed by Abdullah Kokash",
    info: [
      "",
      "Caleb Alexander as William K. Ride",
      "Jon Tylor as Allan Glen",
      "Abdullah Kokash as Philip Collins",
      "",
      "Shot and Edited by Abdullah Kokash",
      "Sound Mixer: Khushi Ramlogun",
      "1st AC: Erick Urquilla",
    ],
    description:
      "Astronauts William K. Ride and Allan Glen break silence on what happened on planet Kepler-50 B and the mysterious death of Philip Collins, the youngest crew member.",
    thumbnail: "/images/thekeplers.png",
    videoUrl: "/videos/KEPLERS_snippet2.mp4",
    youtubeId: "5OyuqPENRIk",
    date: "2025-04-10",
    featured: true,
    categories: [],
    credits: [
      {
        role: "William K.Ride",
        name: "Caleb Alexander",
      },
      {
        role: "Allan Glen",
        name: "Jon Tylor",
      },
    ],
  },
  "madonnas-garden": {
    id: "madonnas-garden",
    title: "Madonna's Garden",
    subtitle: "DRAMA SHORT FILM",
    role: "Director of Photography / Colorist",
    credit: "Written & Directed by Sming Frauenhofer",
    info: [
      "Produced by Sming Frauenhofer & Abdullah Kokash",
      "",
      "Sirena Morales as \"Madonna\"",
      "Dean Schultz as \"Jonah\"",
      "",
      "Edited by Sming Frauenhofer & Abdullah Kokash",
      "Cinematography by Abdullah Kokash",
      "Color and Sound Mix by Abdullah Kokash",
      "Production Assistance by John Chan",
    ],
    description: "Madonna reflects on a dream she had.",
    thumbnail: "/images/madonnas.png",
    videoUrl: "",
    youtubeId: "iIn4dSuNhSE",
    date: "2025-05-14",
    featured: false,
    categories: [],
    credits: [
      {
        role: "Writer/Director",
        name: "Sming Frauenhofer",
      },
      {
        role: "Madonna",
        name: "Sirena Morales",
      },

      {
        role: "Jonah",
        name: "Jeremiah Schultz",
      },
    ],
  },

  "the-devils-veil": {
    id: "the-devils-veil",
    title: "The Devil's Veil Proof of Concept",
    subtitle: "PSYCHOLOGICAL THRILLER",
    role: "Director / Director of Photography / Editor",
    credit: "Written & Directed by Abdullah Kokash",
    info: [
      "Produced by Sue-Ming Frauenhofer & Abdullah Kokash",
      "",
      "Jon Tylor as Mark",
      "Leah Sloan as Evelynn",
      "Julia Bloom as Emma",
      "",
      "Director of Photography: Abdullah Kokash",
      "Editor: Abdullah Kokash",
      "Colorist: Abdullah Kokash",
      "1st AD: Andres Aya Cedeño",
      "Assistant Camera: Nia Savory",
      "Gaffer: Ryan Sinner",
      "Sound Mixer: Gabriel Bernard Lee",
      "Production Assistant: Simona Sutka",
      "",
      "Music: \"Boris Kerner\" by Caroline Shaw, New Morse Code",
      "Music: \"Taxidermy\" by Caroline Shaw, So Percussions",
    ],
    description:
      "A proof of concept for The Devil's Veil - A short film about a photographer with undiagnosed agnosia.",
    thumbnail: "/images/thedevilsveil.png",
    videoUrl: "/videos/TDV_snippet.mp4",
    youtubeId: "83izrBBXW1E",
    date: "2025-06-10",
    featured: true,
    categories: [],
    credits: [
      {
        role: "Emma",
        name: "Julia Bloom",
      },
      {
        role: "Evelynn",
        name: "Leah Slaon",
      },
      {
        role: "Mark",
        name: "Jon Tylor",
      },
    ],
  },

  "anthem-for-no-state": {
    id: "anthem-for-no-state",
    title: "Anthem for No State",
    subtitle: "Experimental Narration",
    role: "Writer / Director / Director of Photography / Editor / Colorist",
    credit: "Shot, Edited, Colored, Written and Directed by Abdullah Kokash",
    description:
      "This film is inspired by the location in which we shot it at, Bombay Beach, as well as the incredibly beautiful music by Godspeed You! Black Emperor, specifically their F#A# Album.\n\nThis is my first time writing music for a film - the compositions you hear in the beginning and at the end of the film is made by me. The haunting guitar sounds were made by Tap Rudra.",
    info: [
      "Voice actors: Brenna Ryan, Elliot Gagne",
      "Actors: Nick Gangone, John Chan",
    ],
    thumbnail: "/images/projects/anthem-for-no-state/thumb.jpg",
    stills: [
      "/images/projects/anthem-for-no-state/still-1.jpg",
      "/images/projects/anthem-for-no-state/still-2.jpg",
      "/images/projects/anthem-for-no-state/still-3.jpg",
      "/images/projects/anthem-for-no-state/still-4.jpg",
    ],
    youtubeId: "GDXMNfpIKJ4",
    date: "2026-02-01",
    featured: false,
    categories: ["experimental", "short-film"],
  },

  espinal: {
    id: "espinal",
    title: "Espinal",
    subtitle: "Surreal Drama",
    role: "Writer / Director / Director of Photography / Editor / Colorist",
    credit: "Shot, Edited, Colored, Written and Directed by Abdullah Kokash",
    description:
      "After years abroad, a translator washes up on the shore of her own homeland and must survive an absurd interrogation about why she wants to come home. Loosely based on \"Wild Thorns\" by Sahar Khalifeh.",
    info: [
      "",
      "Sirena Morales as Yamaris Espinal",
      "Ryan Sinner as The Immigration Officer",
      "Chirag Matta as The Man",
      "",
      "1st AC & Camera Operator: Mohamed Madboly",
      "2nd AC: Malika Boseman",
      "Sound Mixers: Dean Schultz & Essam Al-Jahmi",
      "1st AD: Rebecca Shoptaw",
      "On Set Producer: Andre Wells",
      "Script Supervisor: Daria Moykovsky",
      "BTS: Zeke Winitsky",
      "Production Assistants: Dylan Castagnette & Chirag Matta",
      "",
      "Special Thanks: Gerthy Israel, Jarika Johnson, Sirena Morales & Rebecca Shoptaw",
    ],
    thumbnail: "/images/projects/espinal/thumb.jpg",
    stills: [
      "/images/projects/espinal/still-1.jpg",
      "/images/projects/espinal/still-2.jpg",
      "/images/projects/espinal/still-3.jpg",
      "/images/projects/espinal/still-4.jpg",
    ],
    stillsAspect: "4 / 3",
    vimeoId: "1230414012",
    vimeoHash: "18ede3f9a4",
    date: "2026-09-01",
    featured: false,
    categories: ["drama", "short-film"],
  },
  "the-flag": {
    id: "the-flag",
    title: "The Flag",
    role: "Writer / Director / Producer",
    credit: "Directed, Written & Produced by Abdullah Kokash",
    info: [
      "",
      "Abdullah Kokash as Abdullah",
      "Razi Kittaneh as Razi",
      "Nicolas Gangone as Nick",
      "Sue-Ming Frauenhofer as Sming",
      "",
      "Director of Photography: Ryan Sinner",
      "Camera Operators: Bo Deng & Steven Wang",
      "Gaffer: Zooey Mills",
      "Sound: Khushi Ramlogun & Caleb Alexander",
      "Animator: Max Borchardt",
    ],
    description:
      "Jordanian-Palestinian filmmaker Abdullah Kokash, based in Brooklyn on a US visa, wants to include one charged image in his film. Afraid of the consequences after Trump's recent executive order, he turns the camera on himself instead, documenting his fear and his struggle over whether to include it. He talks to friends, collaborators, and the camera about what he's allowed to show and at what cost. What begins as a question about a single image in a fictional film grows into a wider conversation about the First Amendment, who it belongs to, and whether America's promise of free speech is a broken one.",
    thumbnail: "/images/projects/the-flag/thumb.jpg",
    date: "2026-04-01",
    screenerOnRequest: true,
    featured: false,
    categories: ["short-film"],
  },
};

/**
 * Helper function to get projects for the carousel
 * @returns {Project[]} Array of featured projects
 */
export const getFeaturedProjects = () =>
  Object.values(projectsData)
    .filter((project) => project.featured && !project.hidden)
    .sort((a, b) => new Date(b.date) - new Date(a.date));

/**
 * Helper function to get projects for the grid display
 * @param {number|string[]} limitOrIds - Either a number limit or array of specific project IDs
 * @param {string[]} categories - Optional categories to filter by
 * @returns {Project[]} Array of projects
 */
export const getGridProjects = (limitOrIds = 0, categories = []) => {
  // If array of IDs is provided, return those specific projects
  if (Array.isArray(limitOrIds)) {
    return limitOrIds
      .map((id) => projectsData[id])
      .filter((project) => project && !project.hidden); // Filter out any undefined projects (in case of invalid IDs)
  }

  // Otherwise, treat as a limit number
  let projects = Object.values(projectsData).filter((p) => !p.hidden);

  // Filter by categories if provided
  if (categories.length > 0) {
    projects = projects.filter((project) =>
      project.categories?.some((category) => categories.includes(category)),
    );
  }

  // Sort by date (newest first)
  projects = projects.sort((a, b) => new Date(b.date) - new Date(a.date));

  // Apply limit if provided
  if (limitOrIds > 0) {
    projects = projects.slice(0, limitOrIds);
  }

  return projects;
};

/**
 * Get a project by its ID
 * @param {string} id - Project ID
 * @returns {Project|null} Project object or null if not found
 */
export const getProjectById = (id) => projectsData[id] || null;

/**
 * Photography series/collections
 * Each series is a themed collection of photos
 * @type {Object<string, PhotoSeries>}
 */
export const photographySeries = {
  portraits: {
    id: "portraits",
    title: "Portraits",
    description: "Character studies and intimate portraits",
    coverImage: "/images/photography/por4.jpg",
    photos: [
      {
        id: 70,
        src: "/images/photography/por1.jpg",
        alt: "Amr",
      },
      {
        id: 885,
        src: "/images/photography/por5.jpg",
        alt: "sming",
      },
      {
        id: 78,
        src: "/images/photography/por3.jpg",
        alt: "Dean",
      },

      {
        id: 79,
        src: "/images/photography/por4.jpg",
        alt: "Jon",
      },
      {
        id: 886,
        src: "/images/photography/por6.jpg",
        alt: "Vic",
      },
      {
        id: 1,
        src: "/images/photography/photo1.jpg",
        alt: "Nour",
      },
      {
        id: 887,
        src: "/images/photography/por7.jpg",
        alt: "Sirena",
      },

      {
        id: 888,
        src: "/images/photography/por9.jpg",
        alt: "Sirena",
      },
      {
        id: 6,
        src: "/images/photography/photo6.jpg",
        alt: "Ahmad",
      },

      {
        id: 77,
        src: "/images/photography/por2.jpg",
        alt: "Erick",
      },
      {
        id: 7,
        src: "/images/photography/photo7.jpg",
        alt: "Youseff",
      },
    ],
  },
  nature: {
    id: "nature",
    title: "Nature & Landscapes",
    description: "Natural beauty and scenic views",
    coverImage: "/images/photography/photo4.jpg",
    photos: [
      {
        id: 331,
        src: "/images/photography/Nature1.jpg",
        alt: "Jordan",
      },
      {
        id: 331,
        src: "/images/photography/Nature2.jpg",
        alt: "Jordan",
      },
      {
        id: 331,
        src: "/images/photography/Nature3.jpg",
        alt: "Jordan",
      },
      {
        id: 2,
        src: "/images/photography/photo2.jpg",
        alt: "Nature in SF",
      },
      {
        id: 4,
        src: "/images/photography/photo4.jpg",
        alt: "Amman",
      },
      {
        id: 8,
        src: "/images/photography/photo8.jpg",
        alt: "Beautiful Autumn day in Rochester",
      },
      {
        id: 9,
        src: "/images/photography/photo9.jpg",
        alt: "Blue sky, Amman",
      },
      {
        id: 3,
        src: "/images/photography/photo3.jpg",
        alt: "Coney Island",
      },
    ],
  },
  film: {
    id: "film",
    title: "Film Photography",
    description: "Shot on 35mm film",
    coverImage: "/images/photography/photo10.jpg",
    photos: [
      {
        id: 5,
        src: "/images/photography/photo5.jpg",
        alt: "Coney Island on Film",
      },

      {
        id: 30,
        src: "/images/photography/photo10.jpg",
        alt: "SF",
      },

      {
        id: 20,
        src: "/images/photography/Film20.jpg",
        alt: "Jabal Amman",
      },

      {
        id: 21,
        src: "/images/photography/film21.jpg",
        alt: "Downtown Amman",
      },
      {
        id: 22,
        src: "/images/photography/film22.jpg",
        alt: "Jordan in the Spring",
      },
    ],
  },
  jordan2024: {
    id: "jordan2024",
    title: "Spring of 2024",
    description: "Shot on 35mm film",
    coverImage: "/images/photography/film22.jpg",
    photos: [
      {
        id: 70,
        src: "/images/photography/por1.jpg",
        alt: "Amr",
      },
      {
        id: 5,
        src: "/images/photography/Nature1.jpg",
        alt: "",
      },

      {
        id: 30,
        src: "/images/photography/Nature2.jpg",
        alt: "",
      },

      {
        id: 20,
        src: "/images/photography/Nature3.jpg",
        alt: "",
      },

      {
        id: 222,
        src: "/images/photography/23 (1).jpg",
        alt: "",
      },
    ],
  },
};

/**
 * Get all photography series
 * @returns {PhotoSeries[]} Array of all series
 */
export const getAllSeries = () => Object.values(photographySeries);

/**
 * Get a specific series by ID
 * @param {string} id - Series ID
 * @returns {PhotoSeries|null} Series object or null if not found
 */
export const getSeriesById = (id) => photographySeries[id] || null;
